export default __webpack_public_path__ + "static/media/construction.94965587.jpg";